// Entry point. The Firebase SDK is a separate chunk loaded only when a signed-in
// screen needs it, so a customer opening a QuoteLink on a phone never downloads it.
import React from "react";
import { createRoot } from "react-dom/client";
import { createApi } from "./api.js";
import type { AuthClient } from "./auth.js";
import { App } from "./App.js";

let client: AuthClient | null = null;
let loading: Promise<AuthClient> | null = null;

const api = createApi({ token: (force) => (client ? client.idToken(force) : Promise.resolve(null)) });

function loadAuth(): Promise<AuthClient> {
  loading ??= (async () => {
    const config = await api.config();
    // Dynamic on purpose: esbuild splits the SDK into its own chunk, so a QuoteLink on a phone never downloads it.
    const { createFirebaseAuth } = await import("./firebase-auth.js");
    client = await createFirebaseAuth(config);
    return client;
  })().catch((err: unknown) => {
    loading = null;
    throw err;
  });
  return loading;
}

const root = document.getElementById("root");
if (root) createRoot(root).render(<App api={api} loadAuth={loadAuth} />);
